import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Tab, Tabs, TextField, Box, Typography, Grid, IconButton, DialogActions } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import moment from "moment";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";
import StatusBadge from "components/badge/StatusBadge";
import { useLazyGetLeadsListQuery } from "store/slices/apis/leadsApiSlice";



const LeaseListPopUp = (props) => {
    const { header, open, handleClose, filter } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(5);
    const dispatch = useDispatch();
    const [subTabValue, setSubTabValue] = useState(0)


    const [filters, setFilters] = useState({
        ...filter,
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,


    });

    const [trigger, { data: leadsList, isFetching }] = useLazyGetLeadsListQuery();

    useEffect(() => {
        trigger(filters);
    }, []);




    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };

    const numericRenderer = (field) => (row) => {
        const value = row?.[field];

        if (!value && value !== 0) return "N/A";

        return Number(value).toLocaleString("en-IN");
    };

    const col = [
        {
            name: "ID",
            field: "customId",
            width: "100px",
            sticky: true,
        },
        {
            name: "Name",
            field: "name",
            width: "200px",
            sticky: true,
            // renderer: (row) => row?.name ? highlightText(row.name, searchTerm) : "N/A",
        },
        {
            name: "Asset Name",
            field: "assetName",
            width: "200px",
            sticky: true,
            // renderer: (row) => row?.assetName ? highlightText(row.assetName, searchTerm) : "N/A",
        },
        {
            name: "Asset Type",
            field: "assetType",
            width: "250px",
            // renderer: (row) => row?.assetType ? highlightText(row.assetType, searchTerm) : "N/A",
        },
        {
            name: "Area In Sqft",
            field: "area",
            width: "200px",
            renderer: numericRenderer("area"),
        },
        {
            name: "Expectation Rental Rate",
            field: "expectationRentalRate",
            renderer: numericRenderer("expectationRentalRate"),
        },
        {
            name: "Status",
            field: "status",
            renderer: (row) => (
                row?.status ? <StatusBadge status={row?.status} /> : ""
            )
        },
        {
            name: "Type",
            field: "type",
            // renderer: (row) => row?.type ? highlightText(row.type, searchTerm) : "N/A",
        },
        {
            name: "Site Visit Date",
            field: "siteVisitDate",
            renderer: (row) => (
                row?.siteVisitDate ? moment.utc(row.siteVisitDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Start Date",
            field: "startDate",
            renderer: (row) => (
                row?.startDate ? moment.utc(row.startDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Source",
            field: "source",
            renderer: (row) => row?.source ? row?.source : "N/A",
        },
        {
            name: "Proposal Date",
            field: "proposalDate",
            renderer: (row) => (
                row?.proposalDate ? moment.utc(row.proposalDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Proposed Rental Base",
            field: "proposedRentalBase",
            renderer: numericRenderer("proposedRentalBase"),
        },
        {
            name: "Proposed Rental CAM",
            field: "proposedRentalCam",
            renderer: numericRenderer("proposedRentalCam"),
        },
        {
            name: "Proposed Rental TI",
            field: "proposedRentalTi",
            renderer: numericRenderer("proposedRentalTi"),
        },
        {
            name: "Current Stage",
            field: "currentStage",
            // renderer: (row) => row?.currentStage ? highlightText(row.currentStage, searchTerm) : "N/A",
        },
        {
            name: "LOI Date",
            field: "loiDate",
            renderer: (row) => (
                row?.loiDate ? moment.utc(row.loiDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Time To Deal",
            field: "timeToDeal",
            renderer: (row) => row?.timeToDeal ?? "N/A",
        },
    ];




    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >

            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={col}
                            data={leadsList?.data || []}
                            createSortHandler={handleRequestSort}
                            loading={isFetching}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={leadsList?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default LeaseListPopUp;
